<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques" :showIsAssign="true" :showInputCheck="true">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}文字題
    </template>
    <v-card-text slot="content" class="text-start">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx" class="blod quest_topic">{{ name }}</div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>
      <v-textarea
        :disabled="
          $store.state.PhoneNum !== null && ques.isAssign && ques.inputCheck === '30'
        "
        outlined
        rows="1"
        auto-grow
        label="回答內容"
        :rules="[
          // 檢查必填
          v => {
            let pass = !(ques.isRequired && !ques.value)
            return pass ? true : '此題為必填'
          },
          // 輸入檢查
          v => {
            switch (this.ques.inputCheck) {
              case '10':
                if (!v || v.length === 0) return true
                if (!/[0-9]{8}/.test(this.ques.value)) return '請填寫正確的統一編號'
                break
              case '20':
                if (!v || v.length === 0) return true
                if (!/.+@.+\..+/.test(this.ques.value.toLowerCase()))
                  return '請填寫正確的電子郵件'
                break
              case '30':
                if (!v || v.length === 0) return true
                // 如果是 isAssign 就是手機，否則可能是市話
                if (this.ques.isAssign) {
                  return /^09[0-9]{2}-?[0-9]{6}$/.test(this.ques.value)
                    ? true
                    : '請填寫正確的手機'
                }
                return /^([0-9]{2,3}-?)?[0-9]{7,8}$/.test(this.ques.value)
                  ? true
                  : '請填寫正確的電話'
                break
              default:
                return true
            }
          }
        ]"
        v-model="ques.value"
        :maxlength="ques.length"
        class="mt-2"
      ></v-textarea>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '文字題',
          cnName: '文字題題目內容',
          length: 20,
          value: 3
        }
      }
    }
  },
  computed: {
    disableInput() {
      // 如果是商業獅會員()，並且指定檢核為手機(inputCheck==='30')
      return this.ques.inputCheck
    }
  },
  data() {
    return {
      // inputCheck	inputCheckName
      // 10	統一編號 // 20	電子郵件 // 30	電話 // 40	網址
      // assignCheck	assignCheckTypeName	inputCheck
      // 10	電子郵件	20 // 20	手機	3
      rules: [
        v => {
          // 檢查必填
          switch (this.ques.inputCheck) {
            case '10':
              if (!!v) return '這是必填欄位'
              if (!/[0-9]{8}/.test(this.ques.value)) return '請填寫正確的統一編號'
              break
            case '20':
              if (!!v) return '這是必填欄位'
              if (!/.+@.+\..+/.test(this.ques.value.toLowerCase()))
                return '請填寫正確的電子郵件'
              break
            case '30':
              if (!!v) return '這是必填欄位'
              // 如果是 isAssign 就是手機，否則可能是市話
              if (this.ques.isAssign) {
                return /^09[0-9]{2}-?[0-9]{6}$/.test(this.ques.value)
                  ? true
                  : '請填寫正確的手機'
              }
              return /^([0-9]{2,3}-?)?[0-9]{7,8}$/.test(this.ques.value)
                ? true
                : '請填寫正確的電話'
              break
            default:
              return true
          }
        }
      ]
    }
  },
  computed: {
    value() {
      return this.ques.value
    }
  },
  watch: {
    value(newValue, oldValue) {
      let lengthLimit = this.ques.length
      if (newValue.length > lengthLimit && lengthLimit >= 0) {
        this.ques.value = newValue.substr(0, lengthLimit)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
//控制輸入的字體大小
*{
  font-size: 2vmin;
}
</style>
